import React from "react";

function IconToolkit() {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 19">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.5 4.525v-.5h5v.5H13v-1a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v1h1.5Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 6.025H3a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5Zm-12-1.5a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2H3Z"
      />
      <path d="M6 7.775a.75.75 0 0 1 .75.75v.25h4.5v-.25a.75.75 0 0 1 1.5 0v.25H17v1.5h-4.25v.25a.75.75 0 0 1-1.5 0v-.25h-4.5v.25a.75.75 0 0 1-1.5 0v-.25H1.5v-1.5h3.75v-.25a.75.75 0 0 1 .75-.75Z" />
    </svg>
  );
}

export default IconToolkit;
